import { useTranslation } from "next-i18next"

const useProjectSubmissionsi18n = componentProps => {
  const { t } = useTranslation("common")
  const authoredOrTranslated = (property, key, defaultValue) =>
    componentProps?.[property] || t(key, { defaultValue })

  return {
    contactInformation: authoredOrTranslated(
      "contactinformation",
      "kf.contactus.label.contactInformation",
      "Contact Information"
    ),
    projectInformation: authoredOrTranslated(
      "projectinformation",
      "kf.projectSubmissions.label.projectInformation",
      "Project Information"
    ),
    attribution: authoredOrTranslated(
      "attribution",
      "kf.projectSubmissions.label.attribution",
      "Attribution"
    ),
    requiredText: authoredOrTranslated(
      "requiredfieldstext",
      "kf.auth.label.requiredFields",
      "Fields marked with * are required."
    ),
    firstName: authoredOrTranslated(
      "firstnamelabel",
      "kf.contactus.label.firstName",
      "First Name"
    ),
    lastName: authoredOrTranslated(
      "lastnamelabel",
      "kf.contactus.label.lastName",
      "Last Name"
    ),
    email: authoredOrTranslated(
      "emaillabel",
      "kf.contactus.label.emailAddress",
      "Email Address"
    ),
    company: authoredOrTranslated(
      "companylabel",
      "kf.projectSubmissions.label.company",
      "Company"
    ),
    projectName: authoredOrTranslated(
      "projectnamelabel",
      "kf.projectSubmissions.label.projectName",
      "Project Name"
    ),
    projectLocation: authoredOrTranslated(
      "projectlocationlabel",
      "kf.projectSubmissions.label.projectLocation",
      "Project Location"
    ),
    city: authoredOrTranslated("citylabel", "kf.contactus.label.city", "City"),
    state: authoredOrTranslated(
      "statelabel",
      "kf.contactus.label.state",
      "State"
    ),
    projectType: authoredOrTranslated(
      "projecttypelabel",
      "kf.projectSubmissions.label.projectType",
      "Project Type"
    ),
    orderNumber: authoredOrTranslated(
      "ordernumberlabel",
      "kf.orderDetails.label.orderNumber",
      "Order Number"
    ),
    productsUsed: authoredOrTranslated(
      "productsusedlabel",
      "kf.projectSubmissions.label.productsUsed",
      "Products Used"
    ),
    projectDescription: authoredOrTranslated(
      "projectdescriptionlabel",
      "kf.projectSubmissions.label.projectDescription",
      "Project Description"
    ),
    projectLink: authoredOrTranslated(
      "projectlinklabel",
      "kf.projectSubmissions.label.projectLink",
      "Project Link"
    ),
    designer: authoredOrTranslated(
      "designerlabel",
      "kf.projectSubmissions.label.designer",
      "Designer"
    ),
    photographer: authoredOrTranslated(
      "photographerlabel",
      "kf.projectSubmissions.label.photographer",
      "Photographer"
    ),
    uploadTitle: authoredOrTranslated(
      "uploadtitle",
      "kf.projectSubmissions.label.uploadTitle",
      "Upload Project Photos/Documents"
    ),
    uploadCount: authoredOrTranslated(
      "uploadcounttext",
      "kf.contactus.label.uploadCountLimit",
      "Upload up to 5 photos/documents"
    ),
    uploadFormats: authoredOrTranslated(
      "uploadformatstext",
      "kf.projectSubmissions.label.uploadFormats",
      "Supported Files Are: .jpg, .gif, .png, .pdf"
    ),
    uploadSize: authoredOrTranslated(
      "uploadsizetext",
      "kf.projectSubmissions.label.uploadSize",
      "Maximum File Size per image: 5MB"
    ),
    dragAndDrop: authoredOrTranslated(
      "draganddroplabel",
      "kf.contactus.label.dragAndDrop",
      "Drag & Drop"
    ),
    or: authoredOrTranslated("orlabel", "kf.contactus.label.orText", "or"),
    uploadFile: authoredOrTranslated(
      "uploadfilelabel",
      "kf.contactus.label.uploadFileButton",
      "Upload File"
    ),
    disclaimer: authoredOrTranslated(
      "disclaimertext",
      "kf.projectSubmissions.label.disclaimer",
      "Disclaimer text"
    ),
    agreement: authoredOrTranslated(
      "agreementlabel",
      "kf.projectSubmissions.label.agreement",
      "Disclaimer agreement"
    ),
    submit: authoredOrTranslated(
      "submitlabel",
      "kf.contactus.label.submitButton",
      "Submit"
    ),
    successTitle: authoredOrTranslated(
      "successtitle",
      "kf.projectSubmissions.label.successTitle",
      "Your project has been submitted."
    ),
    successDescription: authoredOrTranslated(
      "successdescription",
      "kf.projectSubmissions.label.successDescription",
      "Thank you for sharing your work with us, we love seeing how our tile and stone come to life in your work. You'll hear back within 1-3 business days if your project is selected for feature."
    ),
    backToProjectSubmission: authoredOrTranslated(
      "backlabel",
      "kf.projectSubmissions.label.backToProjectSubmission",
      "Back to Project Submission"
    ),
    continueShopping: authoredOrTranslated(
      "continueshoppinglabel",
      "kf.contactus.label.continueShopping",
      "Continue Shopping"
    ),
    genericError:
      componentProps?.errormessage ||
      componentProps?.errorMessage ||
      t("kf.contactus.error.serverError", {
        defaultValue: "We could not submit the form. Please try again later.",
      }),
    firstNameRequired: t("kf.contactus.error.fnameError", {
      defaultValue: "Your first name is required.",
    }),
    lastNameRequired: t("kf.contactus.error.lnameError", {
      defaultValue: "Your last name is required",
    }),
    emailRequired: t("kf.contactus.error.noEmailError", {
      defaultValue: "Please provide your email address",
    }),
    cityRequired: t("kf.projectSubmissions.error.cityRequired", {
      defaultValue: "Please provide your city name",
    }),
    stateRequired: t("kf.projectSubmissions.error.stateRequired", {
      defaultValue: "Please provide your State",
    }),
    projectTypeRequired: t("kf.projectSubmissions.error.projectTypeRequired", {
      defaultValue: "Please provide your Project Type",
    }),
    lettersAndSpacesError: t("kf.projectSubmissions.error.lettersAndSpaces", {
      defaultValue: "Please enter letters and spaces only.",
    }),
    lettersNumbersSpacesError: t(
      "kf.projectSubmissions.error.lettersNumbersSpaces",
      {
        defaultValue: "Please enter letters, numbers and spaces only.",
      }
    ),
    validProjectLinkError: t("kf.projectSubmissions.error.validProjectLink", {
      defaultValue: "Please enter a complete and valid URL.",
    }),
    uploadFileSizeError: t("kf.projectSubmissions.error.maxFileSizeLimit", {
      defaultValue: "You have exceeded the maximum file size limit of 5MB.",
    }),
    uploadFileTypeError: t("kf.projectSubmissions.error.fileType", {
      defaultValue: "Please upload a PNG, JPG, GIF, or PDF file.",
    }),
    imageRemoved: t("kf.projectSubmissions.label.imageRemoved", {
      defaultValue: "Image removed",
    }),
    validEmailError: t("kf.projectSubmissions.error.validEmail", {
      defaultValue: "Please enter a valid email address.",
    }),
    projectTypes: t("kf.projectSubmissions.label.projectTypes", {
      defaultValue: "Residential,Commercial,Hospitality",
    }),
    other: t("kf.projectSubmissions.label.other", {
      defaultValue: "Other",
    }),
    privacyPolicy: t("kf.contactus.label.privacyPolicy", {
      defaultValue: "Privacy Policy",
    }),
    googlePrivacyPolicy: t(
      "kf.associatemembership.label.privacyPolicyGoogle",
      {
        defaultValue: "Google Privacy Policy",
      }
    ),
    subjectAccessRequest: t("kf.contactus.label.subjectAccessRequest", {
      defaultValue: "Subject Access Request",
    }),
    termsOfService: t("kf.contactus.label.termsOfService", {
      defaultValue: "Terms of Service",
    }),
    protectedByGoogle: t("kf.associatemembership.label.protectedByGoogle", {
      defaultValue: "This site is protected by reCAPTCHA and the Google",
    }),
    and: t("kf.contactus.message.and", {
      defaultValue: "and",
    }),
    apply: t("kf.contactus.message.apply", {
      defaultValue: "apply.",
    }),
    submitting: t("kf.projectSubmissions.label.submitting", {
      defaultValue: "Submitting…",
    }),
    charactersUsed: t("kf.projectSubmissions.label.charactersUsed", {
      defaultValue: "of",
    }),
    uploadingFiles: t("kf.projectSubmissions.label.uploadingFiles", {
      defaultValue: "Uploading files",
    }),
    uploadFailed: t("kf.projectSubmissions.error.uploadFailed", {
      defaultValue:
        "The selected files could not be uploaded. Please try again.",
    }),
    filesUploaded: t("kf.projectSubmissions.label.filesUploaded", {
      defaultValue: "files uploaded",
    }),
    removeFile: t("kf.projectSubmissions.label.removeFile", {
      defaultValue: "Remove",
    }),
    fileRemoved: t("kf.projectSubmissions.label.fileRemoved", {
      defaultValue: "removed",
    }),
    errorSummaryTitle: t("kf.projectSubmissions.error.summaryTitle", {
      defaultValue: "Please correct the following errors",
    }),
    submitIncompleteHelp: t(
      "kf.projectSubmissions.label.submitIncompleteHelp",
      {
        defaultValue:
          "Some required information is missing or invalid. Submit to review the errors.",
      }
    ),
    submitReadyHelp: t("kf.projectSubmissions.label.submitReadyHelp", {
      defaultValue: "The form is ready to submit.",
    }),
    opensInNewTab: t("kf.projectSubmissions.label.opensInNewTab", {
      defaultValue: "Opens in a new tab after confirmation.",
    }),
  }
}

export default useProjectSubmissionsi18n
